function removeClassStartingWith(element, prefix, position = 0) {
  const classes = element.className
    .split(' ')
    .filter(c => !c.startsWith(prefix, position))
  element.className = classes.join(' ').trim()
}

export default removeClassStartingWith
